import { render, staticRenderFns } from "./Resi.vue?vue&type=template&id=127fe268&"
import script from "./Resi.vue?vue&type=script&lang=js&"
export * from "./Resi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports